export const ENDPOINTS = {
  login: () =>
    `/api/v1/auth?frontend_protocol=${window.location.protocol.replace(":", "")}&frontend_host=${window.location.host}&comeback_path=${window.location.pathname}${encodeURIComponent(window.location.search)}`,
  logout: () =>
    `/api/v1/auth/logout?frontend_protocol=${window.location.protocol.replace(":", "")}&frontend_host=${window.location.host}`,
  token: "/api/v1/auth/token",
  getCurrentUser: "/api/v1/user",
  getUsers: "/api/v1/user/list",
  permissions: "/api/v1/users/me/permissions",
  notificationVapidFCM: "/api/v1/notifications/vapid/fcm",
  notificationVapidPush: "/api/v1/notifications/vapid/push",
  notificationRegisterFCM: "/api/v1/notifications/register/fcm",
  notificationRegisterPush: "/api/v1/notifications/register/push",
  notificationSendFCM: "/api/v1/notifications/fcm",
  notificationSendPush: "/api/v1/notifications/push",
  notificationUnregisterPush: "/api/v1/notifications/unregister/push",
  getTrafficProviderName: "/api/v1/traffic_provider/name",
  getStatistics: "/api/v1/statistics",
  getStatisticsFile: "/api/v1/statistics/file",
  getReportList: "/api/v1/report/list",
  getReportById: (id: number | string) => `/api/v1/report/${id}`,
  createReport: "/api/v1/report/create",
  updateReport: (id: number | string) => `/api/v1/report/update/${id}`,
  getCampaignList: "/api/v1/campaign/list/name",
  getOfferList: "/api/v1/offer/list/name",
  getTriggerList: "/api/v1/trigger/list/name",
  getCreativeList: "/api/v1/creative/list/name",
  getMailingTypeList: "/api/v1/mailingType/list",
  createSummaryTemplate: "/api/v1/summary_template/create",
  updateSummaryTemplate: (id: number | string) => `/api/v1/summary_template/update/${id}`,
  getSummaryTemplateById: (id: number | string) => `/api/v1/summary_template/${id}`,
  getSummaryTemplateList: "/api/v1/summary_template/list",
  getSummaryList: "/api/v1/summary/list",
  getSummaryById: (id: number | string) => `/api/v1/summary/${id}`,
};
